import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Link } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackClickOnBookedShowMoreButton, trackShowBookedShowMoreButton } from './tracking';
import { useOfferContext } from '../../../context';
import { isNewbuildingBookedFromDeveloper } from '../../../utils/newbuildingBooking';
import { addMortgageTypeToUrl, getMortgageType } from '../PriceContainer/utils';
import { getTermsValue } from 'shared/json_query/reducers/helpers';
import { selectSource } from 'shared/selectors';
import { selectMlSearchSessionGuid } from 'shared/selectors/mlSearchSessionGuid';
import { selectJsonQuery } from 'shared/selectors/results';
import { useApplicationContext } from 'shared/utils/applicationContext';

export function BookedOfferLayoutsLinkContainer() {
  const { offer, jsonQuery: jsonQueryFromContext } = useOfferContext();
  const { config } = useApplicationContext();

  const isBookedFromDeveloper = isNewbuildingBookedFromDeveloper(offer);
  const isV2BookedFromDeveloperEnabled = config.get<boolean>('Newbuilding.BookedFromDeveloperDesktop.Enabled');
  const isBookedFromDeveloperAvaliable = Boolean(isBookedFromDeveloper && isV2BookedFromDeveloperEnabled);

  const jsonQuery = useSelector(selectJsonQuery);
  const jsonQueryToUse = jsonQueryFromContext || jsonQuery;

  const source = useSelector(selectSource);
  const mlSearchSessionGuid = useSelector(selectMlSearchSessionGuid);

  // Получаем выбранные типы ипотеки из фильтров
  const promoSearchTypes = getTermsValue('promo_search_types')(jsonQueryToUse);
  const mortgageType = getMortgageType(promoSearchTypes);

  const handleButtonShow = React.useCallback(() => {
    trackShowBookedShowMoreButton({ offerId: offer.id, mlSearchSessionGuid, source });
  }, [offer.id, mlSearchSessionGuid, source]);

  const handleButtonClick = React.useCallback(() => {
    trackClickOnBookedShowMoreButton({ offerId: offer.id, mlSearchSessionGuid, source });
  }, [offer.id, mlSearchSessionGuid, source]);

  const href = React.useMemo(() => {
    const baseUrl = `${offer.fullUrl}#booked-offer-layouts`;

    return addMortgageTypeToUrl(baseUrl, mortgageType);
  }, [offer.fullUrl, mortgageType]);

  if (!isBookedFromDeveloperAvaliable) {
    return null;
  }

  return (
    <div>
      <ActionAfterViewObserver triggerOnce callback={handleButtonShow}>
        <Link
          fontWeight="bold"
          fontSize="L"
          spacingSize="M"
          data-testid="booked-offer-layouts-link"
          href={href}
          target="_blank"
          afterIcon={<IconActionChevronRightSmall16 color="icon-main-default" />}
          onClick={handleButtonClick}
        >
          Посмотреть похожие квартиры
        </Link>
      </ActionAfterViewObserver>
    </div>
  );
}
